<template>
  <div class="xh-image-item" :class="{'xh-image-item-hover':subtitle}" @click="click">

    <div class="empty-img" v-if="!imgUrl">图片加载失败{{imgUrl}}</div>
    <img :src="imgUrl" v-else>
    <div class="overlay" v-if="title||subtitle"></div>
    <div class="content">
      <div class="title">{{title}}</div>
      <div class="subtitle" v-if="subtitle">{{subtitle}}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    imgUrl: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
  },
  methods: {
    click() {
      this.$emit("click");
    },
  },
};
</script>
<style lang="less" scoped>
.xh-image-item {
  width: 200px;
  height: 200px;
  position: relative;
  overflow: hidden;
  border-radius: 5px;
  transition: all 0.3s ease;
  img {
    width: 100%;
    height: 100%;
    pointer-events: none;
  }
  .overlay {
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    transform: translateY(80%);
    transition: all 0.3s ease;
  }
  .title {
    color: #fff;
    box-sizing: border-box;
    padding: 0 10px;
    position: absolute;
    top: 80%;
    height: 20%;
    width: 100%;
    font-weight: bold;
    font-size: 14px;
    display: flex;
    align-items: center;
    transition: all 0.3s ease;
  }
  .subtitle {
    opacity: 0;
    box-sizing: border-box;
    padding: 0 10px;
    color: #fff;
    font-size: 12px;
    position: absolute;
    top: 60%;
    height: 40%;
    width: 100%;
    display: flex;
    align-items: center;
    transition: all 0.3s ease;
  }
  .empty-img {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    background: rgb(122, 122, 122);
    pointer-events: none;
  }
  &:hover {
    box-shadow: 0 0 15px rgba(0,0,0,0.5);
  }
}
.xh-image-item-hover {
  &:hover {
    .overlay {
      transform: translateY(40%);
    }
    .title {
      top: 40%;
      background: transparent;
    }
    .subtitle {
      opacity: 1;
    }
  }
}
</style>